'use strict';

/** @type {import('./Reflect.setPrototypeOf')} */
module.exports = (typeof Reflect !== 'undefined' && Reflect.setPrototypeOf) || null;



//////////////////
// WEBPACK FOOTER
// ./node_modules/set-proto/Reflect.setPrototypeOf.js
// module id = 659
// module chunks = 0